import ApplicationSchema from './Application.schema';

export const formatDate = (date: Date) => {
  date = new Date(date);
  const day = date.getDate();
  const year = date.getFullYear();
  const month = date.getMonth() + 1;
  return `${year}-${month < 10 ? `0${month}` : month}-${
    day < 10 ? `0${day}` : day
  }`;
};

export const UPDATE_APPLICATION = (application: ApplicationSchema) => {
  let mutation = `mutation {
        updateApplication(
            applicationId: "${application.id}"
            input : {`;

  if (application.coverageStart) {
    mutation += `coverageStart: "${formatDate(application.coverageStart)}",`;
  }
  if (application.communityId) {
    mutation += `communityId: "${application.communityId}",`;
  }
  if (application.buildingName) {
    mutation += `buildingName: "${application.buildingName}",`;
  } else if (application.buildingId) {
    mutation += `buildingId: "${application.buildingId}",`;
  } else if (application.address) {
    mutation += `address: {
                street: "${application.address.street}",
                shortNameStreet: "${application.address.shortNameStreet}",
                municipality:  "${application.address.municipality}",
                addressNumber:  "${application.address.addressNumber}",
                region: ${application.address.state},
                postalCode:  "${application.address.postalCode}",
            },`;
  }
  if (Array.isArray(application.additionalInsuredRoommates)) {
    const additionalInsuredRoommates = application.additionalInsuredRoommates;
    if (additionalInsuredRoommates.length) {
      mutation += 'additionalInsuredRoommates: [';
      additionalInsuredRoommates.forEach((adIR) => {
        mutation += `{
                    firstName: "${adIR.firstName}",
                    lastName: "${adIR.lastName}",
                    email: "${adIR.email}"
                }`;
      });
      mutation += '],';
    }
  }

  if (Array.isArray(application.additionalInterests)) {
    const additionalInterests = application.additionalInterests;
    if (additionalInterests.length) {
      mutation += 'additionalInterests: [';
      additionalInterests.forEach((adIR) => {
        mutation += `{
                    firstName: "${adIR.firstName}",
                    lastName: "${adIR.lastName}",
                    email: "${adIR.email}"
                }`;
      });
      mutation += '],';
    }
  }

  if (application.leaseEnd) {
    mutation += `leaseEnd:"${formatDate(application.leaseEnd)}",`;
  }

  mutation += `
        firstName: "${application.firstName}",
        lastName: "${application.lastName}",
        buildingUnit: "${application.buildingUnit}"
        phone: "${application.phone}",
    }){
        ... on ApplicationOutput {
            id,
            buildingId
        }
        ... on ErrorListOutput {
            errors: errors {
                type
                message
            }
            }
        }
    }`;
  return mutation;
};
